import { z } from "zod";
import { PayoutStatusSchema } from "./payouts";

/**
 * Phase 20 — Event operational / AR / AP progress (derived, not stored).
 * @see docs/performance-show-management/PHASE_20_EVENT_PROGRESS_PERCENT_SPEC.md
 */
export const EventProgressMilestonesSchema = z.object({
  /** null = feature ปิด / ไม่ใช้ */
  team: z.boolean().nullable(),
  /** null = ไม่มี feature documents */
  pricing: z.boolean().nullable(),
  /** null = feature ปิด / ไม่มี session ที่ใช้ได้ */
  rehearsal: z.boolean().nullable(),
  /** null = ไม่มี feature performers หรือ staff (manual) */
  payout: z.boolean().nullable(),
  /** staff-only workflow — แยกจาก pricing (QT) */
  invoiceIssued: z.boolean().optional(),
  /** รับเงินลูกค้าครบ (AR >= 100%) — เมื่อมี feature documents */
  paymentCollected: z.boolean().optional(),
  /** null = feature production_costs ปิด */
  productionCosts: z.boolean().nullable().optional(),
});
export type EventProgressMilestonesDTO = z.infer<
  typeof EventProgressMilestonesSchema
>;

export const EventProgressSchema = z.object({
  /** null เมื่อ event.status = cancelled */
  operationalPercent: z.number().int().min(0).max(100).nullable(),
  milestones: EventProgressMilestonesSchema,
  /** null เมื่อยังไม่มี invoice ที่ไม่ voided */
  arPercent: z.number().int().min(0).max(100).nullable(),
  /** null เมื่อ manual หรือยังไม่มี payout ที่ไม่ cancelled */
  apPercent: z.number().int().min(0).max(100).nullable(),
  /** null เมื่อไม่มี feature production_costs หรือยังไม่มีรายการ */
  productionCostPercent: z.number().int().min(0).max(100).nullable(),
  /** สถานะ batch payout หลักของงาน — null เมื่อไม่มี feature payout */
  payoutStatus: PayoutStatusSchema.nullable(),
});
export type EventProgressDTO = z.infer<typeof EventProgressSchema>;
